import Vue from 'vue'
import { localizedNumber } from 'util/localization-utils'

import withRender from './summary-dim-rating.html'
import './summary-dim.scss'
import './summary-dim-rating.scss'

export default withRender(Vue.extend({
  props: {
    label: { type: String },
    averageRating: {
      type: Number,
      default: 0.0
    }
  },
  computed: {
    ratingDisplay() {
      return `${this.label}: ${localizedNumber(this.averageRating)} / ${localizedNumber(5.0)}`
    },
    ratingPercentage() {
      return `${(this.averageRating / 5.0 * 100).toFixed(1)}%`
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/reviews-summary/summary-dim-rating.ts